<template>
	<div v-if="mounted" class="sections">
		<section>
			<RadioGroup
				v-model="yesNo"
				:options="options"
				@input="yesNoChanged"
			/>
		</section>
		<section>
			<h3>Folgende Tätigkeiten hast du bereits eingegeben:</h3>
			<Functions
				v-model="functions"
				ref="functions"
				:with-edit-button="yesNo === true || !hasFunctions"
				@input="emitChangeEvent"
			/>
		</section>
	</div>
</template>

<script>
import RadioGroup from "@/vue/common/form/RadioGroup";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import Functions from "@/vue/application/Functions.vue";
import {characteristicMultiple} from "@/helper/application/Populate";
import {mapState} from "vuex";

export default {

	components: {
		Functions,
		RadioGroup
	},

	props: {
		initialFunctions: {
			type: Array,
			required: false,
		},
		value: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.functions = characteristicMultiple(
			this.initialFunctions,
			this.meta,
			this.meta.function,
			this.meta.functionType,
			true
		);

		this.mounted = true;
	},

	data ()
	{
		return {
			mounted: false,
			yesNo: undefined,
			functions: undefined,
		};
	},

	computed: {
		...mapState('meta', ['meta']),
		hasFunctions ()
		{
			return isDefined(this.functions) && arrayIsNotEmpty(this.functions);
		},
		options ()
		{
			return [
				{value: true, text: 'Ja, ich könnte mir andere Tätigkeiten vorstellen'},
				{value: false, text: 'Nein, es muss meinem Wunsch entsprechen'},
			]
		},
		valid ()
		{
			return this.yesNo !== undefined && this.hasFunctions;
		}
	},

	methods: {
		yesNoChanged (yesNo)
		{
			if (yesNo)
			{
				this.$refs.functions.edit();
			}

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				functions: this.functions,
				finished: true,
			});
		}
	}
}
</script>
